import React from 'react';

const SK = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_44"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_44)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#0A58AC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10H21V15H0V10Z"
        fill="#F01F29"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V5H0V0ZM9.93 10H10V5H3V10H3.07C3.024 10.162 3 10.33 3 10.5C3 11.88 6.5 13 6.5 13C6.5 13 10 11.88 10 10.5C10 10.33 9.976 10.162 9.93 10Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 10V4H4V10C4 11.105 6.5 12 6.5 12C6.5 12 9 11.105 9 10Z"
        fill="#F01F29"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 8V7H5V6H6V5H7V6H8V7H7V8H8.5V9H7V10H6V9H4.5V8H6Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 12C6.5 12 9 11.105 9 10C9 8.895 8 9 6.5 10C5 9 4 8.895 4 10C4 11.105 6.5 12 6.5 12Z"
        fill="#0A58AC"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default SK;
